export default {
  style: 'currency',
  currency: 'BRL',
  minimumFractionDigits: 2,
};
